.panel {
  padding: 18px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.donutRow { display: flex; justify-content: center; margin-bottom: 12px; }

.list { display: flex; flex-direction: column; gap: 5px; }

.row { display: flex; align-items: center; gap: 8px; font-size: 13.5px; color: var(--text2); }

.swatch { width: 10px; height: 10px; border-radius: 2px; flex-shrink: 0; }
.rowName { flex: 1; }
.rowValue { font-weight: 600; color: var(--text); }

.divider { border-top: 1px solid var(--border); margin-top: 4px; padding-top: 8px; }
